const uploadDefaultState = {
  docToQuizNewPresentationRequestId: null,
  newDocToQuizPresentationId: null,
  docToQuizGlobalImportError: false,
  docToQuizTrackGenerationDone: false,

  // UPLOAD IMAGE
  uploadLocalImageError: null,
  isUploadingLocalImage: false,
  isUploadImageModalVisible: false,
}

export default uploadDefaultState
